import PosWifi from "assets/images/pos/01Icon_2x.png";
import PosMobile from "assets/images/pos/02Icon_2x.png";
import SoftPos from "assets/images/pos/03Icon_2x.png";
import PosBanco from "assets/images/pos/04Icon_2x.png";
import SoftPosWifi from "assets/images/pos/05Icon_2x.png";

export const PosImageConst: { [key: string]: string } = {
	BP55: SoftPos,
	A35ER: PosBanco,
	A35EA: PosBanco,
	A35WR: PosWifi,
	A35WA: PosWifi,
	Q25ER: PosBanco,
	Q25EA: PosBanco,
	A920WR: PosWifi,
	A920WA: PosWifi,
	A920GR: PosMobile,
	A920GA: PosMobile,
	A960WR: PosWifi,
	A960WA: PosWifi,
	A960GR: PosMobile,
	A960GA: PosMobile,
	A960ER: PosBanco,
	A960EA: PosBanco,
	A8700WR: PosWifi,
	A8700WA: PosWifi,
	A8700ER: PosBanco,
	A8700EA: PosBanco,
	S80ER: PosBanco,
	S80EA: PosBanco,
	D210ER: PosBanco,
	D210EA: PosBanco,
	D210GR: PosMobile,
	D210GA: PosMobile,
	D210WR: PosWifi,
	D210WA: PosWifi,
	D195WR: PosWifi,
	D195WA: PosWifi,
	D195GR: SoftPos,
	D195GA: SoftPos,
	A920ER: PosBanco,
	A920EA: PosBanco,
	A50GR: SoftPos,
	A50GA: SoftPos,
	A50WR: SoftPosWifi,
	A50WA: SoftPosWifi,
};
